export const VEHICLE_RESTRICTIONS_FEATURE = 'vehicle restrictions';
